class RangeData {
  constructor(bsrUpper, nMcr, mcr) {
    this.bsrUpper = bsrUpper;
    this.nMcr = nMcr;
    this.mcr = mcr;
  }
}

class ShoptestData {
  constructor(
    rpm,
    power
  ) {
    this.rpm = rpm;
    this.power = power;
  }
}

class SeaTrialsMeasurments {
  constructor(
    rpm,
    power,
    speed,
    bsfc
  ) {
    this.rpm = rpm;
    this.power = power;
    this.speed = speed;
    this.bsfc = bsfc;
  }
}

class SeaTrialsCoefficients {
  constructor(
    cPowerStw,
    nPowerStw,
    cPowerRpm,
    nPowerRpm,
    cRpmStw,
    nRpmStw,
    cStwRpm,
    nStwRpm
  ) {
    this.cPowerStw = cPowerStw;
    this.nPowerStw = nPowerStw;
    this.cPowerRpm = cPowerRpm;
    this.nPowerRpm = nPowerRpm;
    this.cRpmStw = cRpmStw;
    this.nRpmStw = nRpmStw;
    this.cStwRpm = cStwRpm;
    this.nStwRpm = nStwRpm;
  }
}

class SeaTrialsData {
  constructor(
    id,
    meanDraft,
    vesselId,
    measurments,
    coefficients
  ) {
    this.id = id;
    this.meanDraft = meanDraft;
    this.vesselId = vesselId;
    this.measurments = measurments;
    this.coefficients = coefficients;
  }
}
class KDiagramStaticData {
  constructor(
    rangeData,
    shoptestData,
  ) {
    this.rangeData = rangeData;
    this.shoptestData = shoptestData;
  }
}

export { KDiagramStaticData, RangeData, ShoptestData, SeaTrialsData, SeaTrialsMeasurments, SeaTrialsCoefficients };
